import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import PlantConstants from "../Constants/PlantConstants";
class Plant_Action {
  addNewPlant(plant) {
    httpRequest(
      config.webServiceURL + "/Werk/AddNewWerk",
      "POST",
      JSON.stringify({
        ID: plant.ID,
        PlantID: plant.PlantID,
        Bezeichnung: plant.Bezeichnung,
        OrganisationId: plant.OrganisationId,
        ShowKostWithPlantId: plant.ShowKostWithPlantId,
        Language: plant.Language,
        DateFormat: plant.DateFormat,
        TimeZone: plant.TimeZone,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PlantConstants.ADD_NEW_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PlantConstants.ADD_NEW_PLANT_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  updatePlant(plant) {
    httpRequest(
      config.webServiceURL + "/Werk/UpdateWerk",
      "PUT",
      JSON.stringify({
        ID: plant.ID,
        PlantID: plant.PlantID,
        Bezeichnung: plant.Bezeichnung,
        OrganisationId: plant.OrganisationId,
        ShowKostWithPlantId: plant.ShowKostWithPlantId,
        Language: plant.Language,
        DateFormat: plant.DateFormat,
        TimeZone: plant.TimeZone,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PlantConstants.UPDATE_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PlantConstants.UPDATE_PLANT_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  addPlantWebAdmin(plant) {
    httpRequest(
      config.webServiceURL + "/Werk/AddWerk",
      "POST",
      JSON.stringify({
        ID: plant.ID,
        PlantID: plant.PlantID,
        Bezeichnung: plant.Bezeichnung,
        OrganisationId: plant.OrganisationId,
        ShowKostWithPlantId: plant.ShowKostWithPlantId,
        Language: plant.Language,
        DateFormat: plant.DateFormat,
        TimeZone: plant.TimeZone,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PlantConstants.ADD_PLANT_WEBADMIN_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PlantConstants.ADD_PLANT_WEBADMIN_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deletePlant(plantId) {
    httpRequest(
      config.webServiceURL + "/Werk/DeleteWerk/" + plantId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PlantConstants.DELETE_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PlantConstants.DELETE_PLANT_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new Plant_Action();
